<template>
  <div class="record-list">
    <p>{{title}}</p>
    <el-table :data="list" ref="invoiceRecord" border size="small" :header-cell-class-name="headerClass" @selection-change="selectChange">
      <el-table-column v-if="disabled" type="selection" width="45">
        <template slot-scope="scope">
          <el-checkbox v-model="disabled" :disabled="disabled"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column v-else type="selection" width="45"></el-table-column>
      <el-table-column v-for="col in columns" :label="col.name" :prop="col.key" :formatter="col.format" :key="col.key"></el-table-column>
    </el-table>
  </div>
</template>
<script>
  export default {
    name: 'invoice-record',
    model : {
      prop : 'value',
      event : 'change'
    },
    props: {
      value: {
        type: Array,
        default: function() {
          return [];
        }
      },
      valueKey: {
        type: String,
        default: 'recordId'
      },
      title: String,
      list: {
        type: Array,
        default: function() {
          return [];
        }
      },
      columns: {
        type: Array,
        default: function() {
          return [];
        }
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      list(val) {
        this.$nextTick(() => {
          val.forEach(row => {
            this.$refs.invoiceRecord.toggleRowSelection(row, true);
          })
        });
      }
    },
    mounted() {
      this.$refs.invoiceRecord.toggleAllSelection();
    },
    methods: {
      selectChange(selection) {
        const ids = selection.map(it => it[this.valueKey]);
        this.$emit('change', ids);
      },
      headerClass({columnIndex}) {
        if (columnIndex == 0 && this.disabled) {
          return 'check-header';
        }
        return '';
      }
    }
  }
</script>
<style lang="scss">
  .record-list {
    th.el-table__cell.check-header .cell {
      display: none;
    }
  }
</style>